module.exports = __webpack_public_path__ + "img/71_27.cfbbaf66.png";